export default __webpack_public_path__ + "static/media/trailer.2a994141.jpg";